/**
 * Replaces placeholders in a URL string with given parameters.
 *
 * The patternUrl can contain placeholders in the format of `:parameterName`.
 * The function will replace these placeholders with the corresponding values
 * from the params object. If a parameter is missing, it will throw an error
 * unless the forceReplaceAll flag is set to false, in which case the
 * placeholder will be left in the URL string.
 *
 * @param patternUrl The URL string to replace placeholders in.
 * @param params The object with values to replace placeholders with.
 * @param forceReplaceAll Set to false to not throw an error if a parameter is
 *   missing.
 * @returns A URL string with placeholders replaced.
 * @throws An error if a parameter is missing and forceReplaceAll is true.
 */
export function createUrlFromPattern(
  patternUrl: string,
  params: Record<string, string | undefined | null | number>,
  forceReplaceAll = true,
) {
  const urlString = patternUrl.replace(/:\w+/g, (match) => {
    const replaced = params[match.slice(1)];
    if (!replaced) {
      if (!forceReplaceAll) {
        return match;
      }

      throw new Error(
        `Parameter '${match.slice(1)}' is missing for the pattern: ${patternUrl}`,
      );
    }

    return String(replaced);
  });

  return urlString;
}
